import { render, staticRenderFns } from "./drawDetailpage.vue?vue&type=template&id=dbcb19b4&scoped=true"
import script from "./drawDetailpage.vue?vue&type=script&lang=js"
export * from "./drawDetailpage.vue?vue&type=script&lang=js"
import style0 from "./drawDetailpage.vue?vue&type=style&index=0&id=dbcb19b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcb19b4",
  null
  
)

export default component.exports